export { default as useAcceptResultsInDraftTask } from './useAcceptResultsInDraftTask';
